<template>
  <div>
    {{$t('news.template.party.createdConsolidated.p1')}}
    {{news.textParams[0]}}
    {{$t('news.template.party.createdConsolidated.p2')}}
    {{news.textParams[0]}}
    {{$t('news.template.party.createdConsolidated.p3')}} <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >{{news.textParams[1]}}</a> {{$t('news.template.party.created.consolidated.p4')}}
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>
